module.exports = __webpack_public_path__ + "fonts/ralewayextralight.e9e8d83.woff2";